import { CountryCode } from 'shared/constants/countries';

import { useRegion } from '@/hooks/useRegion';

export const useIsPremiumFeatureEnabled = () => {
    const userRegion = useRegion();
    const isUSRegion = userRegion?.code === CountryCode.unitedStates;

    return {
        isPremiumFeatureEnabled: isUSRegion,
        loading: !userRegion,
    };
};
